import React, { useRef, useState } from "react"
import { LoginFormModel } from "../../../models/app/forms/auth/login-form"
import { Box, Button } from "@material-ui/core"
import { EnumDialogs, useDialogStore } from "services/store/dialog-store"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { VariaveisAmbiente } from "ambiente"
import { EnumDeviceType } from "ambiente/ambiente-tipos"
import { DefaultFormRefs } from "components/forms/utils"
import { Login } from "./components/login/login"
import { useThemeQueries } from "theme/util-styles"
import { RedefinirSenha } from "./components/redefinir-senha/redefinir-senha"
import { RedefinirSenhaFormModel } from "models/app/forms/auth/redefinir-senha-form"

export interface DialogAutenticarSenhaProps {
    aberto: boolean,
    callback?: () => void
}

export const DialogAutenticarSenha = ({
    aberto,
    callback
}: DialogAutenticarSenhaProps) => {
    const openCloseDialog = useDialogStore(state => state.openCloseDialog);
    const isCordova = VariaveisAmbiente.deviceType === EnumDeviceType.CORDOVA
    const { isMobile } = useThemeQueries()
    const loginRefs = useRef<DefaultFormRefs<LoginFormModel>>(null);
    const redefinirSenhaRefs = useRef<DefaultFormRefs<RedefinirSenhaFormModel>>(null);
    const [isRedefinirSenha, setIsRedefinirSenha] = useState<boolean>(false)

    return (
        <DialogSaurus
            aberto={aberto}
            titulo={isRedefinirSenha ? "Redefinir Senha ou Ativar Conta" : isCordova ? 'Autenticação de Administrador' : 'Entrar na Conta'}
            isButtonTitleClose
            tamanho="sm"
            fullScreen={isMobile}
            handleClickClose={() => openCloseDialog(EnumDialogs.Autenticar, false)}
            removerPaddingContent
            bottomArea={(
                <Box p={2} gridGap={8} display="flex" flexDirection="column">
                    {isRedefinirSenha ? (
                        <>
                            <Button fullWidth onClick={() => redefinirSenhaRefs.current?.submitForm()} color="primary" size="large" variant="contained">
                                Confirmar
                            </Button>
                            <Button fullWidth onClick={() => setIsRedefinirSenha(false)} color="primary" size="large" variant="outlined">
                                Início
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button fullWidth onClick={() => loginRefs.current?.submitForm()} color="primary" size="large" variant="contained">
                                {!isRedefinirSenha ? "Entrar na Conta" : "Enviar"}
                            </Button>
                            {!isRedefinirSenha && !isCordova && (
                                <Button fullWidth onClick={() => setIsRedefinirSenha(true)} color="primary" size="large" variant="outlined">
                                    Redefinir Senha ou Ativar Conta
                                </Button>
                            )}
                        </>
                    )}
                </Box>
            )}
        >
            <>
                {isRedefinirSenha ? (
                    <RedefinirSenha setIsRedefinirSenha={setIsRedefinirSenha} ref={redefinirSenhaRefs} />
                ) : (
                    <Login loginRefs={loginRefs} isCordova={isCordova} callback={callback} />
                )}
            </>
        </DialogSaurus >
    )
}